module.exports = __webpack_public_path__ + "media/images/webpage/coupons/merit1-70ed40b4e96460bced3325498a7e25e6.svg";